import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import {
  makeStyles,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemAvatar,
  Avatar,
  Divider,
  Button,
  TextField,
  Switch,
  FormControlLabel,
  IconButton,
  Tooltip,
  CircularProgress,
  Fade,
  Collapse,
  Fab,
} from '@material-ui/core'
import Cookies from 'js-cookie'
import {AccountCircle, Edit, AddAPhoto,} from '@material-ui/icons'
import { BiLeftArrowAlt } from 'react-icons/bi'

export default function UserSettings(props) {
  const {open, handleSettingsOpen} = props
  return (
    <div id="user-settings">
      <Fade in={open} timeout={250}mountOnEnter unmountOnExit>
        <Typography variant="caption" className="back-btn" style={{display: "flex", alignItems: "center"}}>
          GO BACK
          <Fab size="small" className="fab" onClick={handleSettingsOpen} style={{marginLeft: '10px'}}>
            <BiLeftArrowAlt />
          </Fab>
        </Typography>
      </Fade>
        {/* <Grid
          container
          justify="center"
          alignItems="center"
          direction="column"
          className="grid"
        > */}

          {/* <Card className="background">

          </Card> */}
        {/* </Grid> */}
        {/* <Typography>Go Back</Typography> */}
        <Fade in={open} timeout={400} mountOnEnter unmountOnExit>
          <div>
            COMING SOON
          </div>
        </Fade>
    </div>
  )
}
